var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 45,
    viewBox: "0 0 34 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_415_36123",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 45
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0098 0.439453H0.404297V44.7484H34.0098V0.439453Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_415_36123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6096 35.5194H28.8808C28.2745 32.8594 26.4205 30.8994 24.2082 30.8994C21.9959 30.8994 20.1433 32.8594 19.5357 35.5194H1.8045C1.0316 35.5194 0.404297 36.3394 0.404297 37.3594C0.404297 38.3794 1.0316 39.2094 1.8045 39.2094H19.5356C20.1419 41.8694 21.9958 43.8193 24.2081 43.8193C26.4205 43.8193 28.273 41.8694 28.8807 39.2094H32.6095C33.3838 39.2094 34.0097 38.3794 34.0097 37.3594C34.0097 36.3394 33.3839 35.5194 32.6096 35.5194ZM24.2082 40.1294C23.0502 40.1294 22.1079 38.8894 22.1079 37.3594C22.1079 35.8394 23.0502 34.5894 24.2082 34.5894C25.3662 34.5894 26.3086 35.8394 26.3086 37.3594C26.3086 38.8894 25.3662 40.1294 24.2082 40.1294ZM32.6096 5.97937H28.8808C28.273 3.31937 26.4205 1.35938 24.2082 1.35938C21.9959 1.35938 20.1433 3.31937 19.5356 5.97937H1.8045C1.0316 5.97937 0.404297 6.79934 0.404297 7.81934C0.404297 8.83934 1.0316 9.66943 1.8045 9.66943H19.5356C20.1433 12.3294 21.9958 14.2794 24.2082 14.2794C26.4206 14.2794 28.2731 12.3294 28.8808 9.66943H32.6096C33.3839 9.66943 34.0098 8.83934 34.0098 7.81934C34.0098 6.79934 33.3839 5.97937 32.6096 5.97937ZM24.2082 10.5894C23.0502 10.5894 22.1079 9.34934 22.1079 7.81934C22.1079 6.29934 23.0502 5.04944 24.2082 5.04944C25.3662 5.04944 26.3086 6.29934 26.3086 7.81934C26.3086 9.34934 25.3662 10.5894 24.2082 10.5894ZM32.6096 20.7494H14.8785C14.2708 18.0894 12.4183 16.1294 10.2059 16.1294C7.99359 16.1294 6.1411 18.0894 5.5334 20.7494H1.8045C1.0316 20.7494 0.404297 21.5694 0.404297 22.5894C0.404297 23.6094 1.0316 24.4393 1.8045 24.4393H5.53329C6.14109 27.0993 7.99359 29.0494 10.2059 29.0494C12.4182 29.0494 14.2708 27.0993 14.8784 24.4393H32.6095C33.3838 24.4393 34.0097 23.6094 34.0097 22.5894C34.0098 21.5694 33.3839 20.7494 32.6096 20.7494ZM10.2059 25.3594C9.04789 25.3594 8.1055 24.1194 8.1055 22.5894C8.1055 21.0694 9.04789 19.8193 10.2059 19.8193C11.3639 19.8193 12.3062 21.0694 12.3062 22.5894C12.3062 24.1194 11.3639 25.3594 10.2059 25.3594Z",
    fill: "#AE8FD6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.11170837984a4a66ae701e41ebc4c832.svg";
export { ForwardRef as ReactComponent };